<template>
  <div id="app">
    <router-view />

    <!-- 模拟聊天按钮 - 未登录时显示 -->
    <!-- <div v-if="showFakeChatButton" class="fake-chat-btn" @click="goToLogin">
      <img src="@/assets/login/service-icon.png" alt="" style="height: 30px" />
    </div> -->
  </div>
</template>
<script>
import WOW from "wowjs";
import { hideMobileChatBtn, showMobileChatBtn } from "./utils/scriptLoader";
import { nextTick } from "vue";
import authMixin from "@/mixins/authMixin";
import { clearAuthStorage, isJwtExpired } from "@/utils/auth-token";

export default {
  computed: {
    isDesktop() {
      return this.$screen.md; // 使用现有的屏幕尺寸判断
    },
    showFakeChatButton() {
      const currentRoute = this.$route.path;
      const isLoginPage = currentRoute === "/login";
      const isRegisterPage = currentRoute === "/register";
      const isResetPage = currentRoute === "/changepwd";
      return (
        this.isDesktop &&
        !this.isLoggedIn() &&
        !isLoginPage &&
        !isRegisterPage &&
        !isResetPage
      );
    },
  },
  watch: {
    "$route.path": {
      handler(to, from) {
        if (!this.$screen.md) {
          nextTick(() => {
            hideMobileChatBtn();
          });
        } else {
          nextTick(() => {
            // if (to === "/login" || to === "/register") {
            //   setTimeout(() => {
            //     hideMobileChatBtn();
            //   }, 800);
            //   return;
            // }
            // showMobileChatBtn();
            this.onChatBtn();
          });
        }
      },
      immediate: true,
    },
  },
  mixins: [authMixin],
  created() {
    this.syncExpiredAuth();
  },
  mounted() {
    var wow = new WOW.WOW({
      boxClass: "wow", // 需要执行动画的元素的 class; 【String类型】默认值：‘wow’；
      animateClass: "animated", // animation.css 动画的 class; 【String类型】默认值：‘animated’；
      offset: 0, // 距离可视区域多少开始执行动画；【整数Number类型】默认值：0；
      mobile: true, // 是否在移动设备上执行动画；【Boolean类型】默认值: true;
      live: true, // 异步加载的内容是否有效；【Boolean类型】默认值: true;
    });
    wow.init();
    // showMobileChatBtn()
    this.onChatBtn();
    //
    // this.handleChatWindow();
  },
  methods: {
    syncExpiredAuth() {
      const token = localStorage.getItem("token");
      const userInfo = localStorage.getItem("userInfo");
      if ((!token && userInfo) || (token && isJwtExpired(token))) {
        clearAuthStorage();
        this.$store.commit("SET_LOGIN", false);
        this.$store.commit("SET_VERIFICATION", "0");
      }
    },
    // 检查用户是否登录
    isLoggedIn() {
      const token = localStorage.getItem("token");
      if (token && isJwtExpired(token)) {
        this.syncExpiredAuth();
        return false;
      }
      return !!token; // 返回布尔值
    },
    // 显示聊天按钮
    onChatBtn() {
      const currentRoute = this.$route.path;
      const isLoginPage = currentRoute === "/login";
      const isRegisterPage = currentRoute === "/register";
      const isResetPage = currentRoute === "/changepwd";

      // 如果在登录、注册或重置密码页面，则隐藏聊天按钮
      if (isLoginPage || isRegisterPage || isResetPage) {
        setTimeout(() => {
          hideMobileChatBtn();
        }, 800);
        return;
      }

      // 在其他页面显示聊天按钮（无论是否登录）
      showMobileChatBtn();
    },
    // 处理客服窗口逻辑
    handleChatWindow() {
      if (this.isLoggedIn()) return;
      // 用户未登录的情况下处理客服窗口
      const currentRoute = this.$route.path;
      const isLoginPage = currentRoute === "/login";
      const isRegisterPage = currentRoute === "/register";
      const isResetPage = currentRoute === "/changepwd";

      // 如果在登录、注册或重置密码页面，不处理客服窗口
      if (isLoginPage || isRegisterPage || isResetPage) {
        return;
      }
      // 检查是否是新窗口或首次访问
      const chatWindowShown = sessionStorage.getItem("chatWindowShown");
      if (!chatWindowShown) {
        // 首次打开或新窗口，自动打开客服窗口
        setTimeout(() => {
          window.kuaizhichat();
          sessionStorage.setItem("chatWindowShown", "true");
        }, 1000);
      }
    },
    // 跳转到登录页面
    goToLogin() {
      this.redirectToLogin(true, "/");
    },
  },
};
</script>
<style lang="scss">
@import "static/scss/style.scss";

#app {
  font-family: -apple-system, blinkmacsystemfont, "Segoe UI", roboto,
    "Helvetica Neue", arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  color: #2c3e50;

  input:focus {
    outline: none;
  }
}
.fake-chat-btn {
  position: fixed;
  right: 14px;
  bottom: 40px;
  z-index: 9999;
  cursor: pointer;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #4077f8;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    transform: scale(1.1);
    transition: transform 0.2s ease;
  }
}
// .fake-chat-btn{
//   width: 50px;
//   height: 50px;
//   img{
//     height: 20px !important;
//   }
// }
</style>
